export function getScreenShareMuted(
  screenShareMutes: Record<string, boolean>,
  userId: string,
): boolean {
  return screenShareMutes[userId] ?? false;
}
